import LayoutPage from '@/view/layout/Layout'

export default [{
    path: '/sheet',
    component: LayoutPage,
    children: [{
        path: 'local/edit/:procesoElectoralId/:localVotacionId/:turno?',
        name: 'sheet-local-edit',
        component: () => import('@/view/sheet/EditFichaLocal'),
        props: (route) => {
            return {
                localVotacionId: Number.parseInt(route.params.localVotacionId, 10),
                procesoElectoralId: Number.parseInt(route.params.procesoElectoralId, 10),
                turno: route.params.turno ? Number.parseInt(route.params.turno, 10) : null,
            }
        },
    },
   /* {
        path: 'local/edit2026/:procesoElectoralId/:localVotacionId/:turno?',
        name: 'sheet-local-edit',
        component: () => import('@/view/sheet/EditFichaLocal2026'),
        props: (route) => {
            return {
                localVotacionId: Number.parseInt(route.params.localVotacionId, 10),
                procesoElectoralId: Number.parseInt(route.params.procesoElectoralId, 10),
                turno: route.params.turno ? Number.parseInt(route.params.turno, 10) : null,
            }
        }
    },*/
    {
        path: 'local/2026/:procesoElectoralId/:localVotacionId/:turno?',
        name: 'sheet-local-edit-2026',
        component: () => import('@/view/sheet/2026/EditFichaLocal'),
        props: (route) => {
            return {
                localVotacionId: Number.parseInt(route.params.localVotacionId, 10),
                procesoElectoralId: Number.parseInt(route.params.procesoElectoralId, 10),
                turno: route.params.turno ? Number.parseInt(route.params.turno, 10) : null,
            }
        }
    },
    {
        path: 'mesa/2026/:procesoElectoralId/:localVotacionId/:mesaVotacionId/:turno?',
        name: 'sheet-mesa-edit-2026',
        component: () => import('@/view/sheet/2026/EditFichaMesa'),
        props: (route) => {
            return {
                localVotacionId: Number.parseInt(route.params.localVotacionId, 10),
                procesoElectoralId: Number.parseInt(route.params.procesoElectoralId, 10),
                mesaVotacionId: Number.parseInt(route.params.mesaVotacionId, 10),
                turno: route.params.turno ? Number.parseInt(route.params.turno, 10) : null,
            }
        }
    }]
}]
